import { Box } from "@mui/material"
import React from "react"
import { AppFormGrid, AppFormSection } from "@components"
import {
	CurrencyField,
	OfficeGroupField,
	OfficePickupField,
	OfficeSwitch,
	SitesField,
} from "Pages/ReportsAlerts/Reports/@components/FormDrawer/Fields"
import { useOfficePickup } from "Pages/ReportsAlerts/Reports/@signals"
import OneWayRoutesField from "Pages/ReportsAlerts/Reports/OneWays/Page/Drawer/Sections/OneWays"
import SheetsField from "Pages/ReportsAlerts/Reports/OneWays/Page/Drawer/Sections/Sheets"

// The Common section with the one way routes and the workbook sheets in place of the drop-off office
export default function ReportFormDrawerSitesOfficesSection() {
	return <AppFormSection
		icon="pager"
		title="Sites & Offices"
		action={<Box data-tour-id="tour-office-switch"><OfficeSwitch/></Box>}
	>
		<AppFormGrid>
			<Box sx={{ gridColumn: 'span 8' }} data-tour-id="tour-office-field">
				<OfficesSubSection/>
			</Box>
			<Box sx={{ gridColumn: 'span 4' }} data-tour-id="tour-currency">
				<CurrencyField/>
			</Box>
			<Box sx={{ gridColumn: 'span 8' }} data-tour-id="tour-site">
				<SitesField/>
			</Box>
			<Box sx={{ gridColumn: '1 / -1' }} data-tour-id="tour-oneway">
				<OneWayRoutesField/>
			</Box>
			<Box sx={{ gridColumn: '1 / -1' }} data-tour-id="tour-sheets">
				<SheetsField/>
			</Box>
		</AppFormGrid>
	</AppFormSection>
}

function OfficesSubSection() {
	return useOfficePickup.value ? <OfficeGroupField/> : <OfficePickupField/>
}
